import { Module } from '../utils';

import authorization from './authorization';
import user from './user';
import home from './home';
import product from './product';
import order from './order';
import common from './common';

import locales from './i18n';
import App from './App';

import './interceptors';

export default new Module(authorization, user, home, product, order, common);
export { locales, App };